import { render, staticRenderFns } from "./PreviewAdd.vue?vue&type=template&id=0a10d0a2&"
import script from "./PreviewAdd.vue?vue&type=script&lang=js&"
export * from "./PreviewAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports